/** Tipos do dominio. Nao dependem do Prisma nem do React de proposito: as regras
 *  rodam igual no servidor (para gravar) e no navegador (para o preview ao vivo). */
export const SPLIT_MODES = ["EQUAL", "WEIGHT", "EXACT", "ITEMS"];
export const LEFTOVER_MODES = ["PROPORTIONAL", "EQUAL"];
export const SETTLEMENT_METHODS = ["PIX", "CASH", "OTHER"];
export const GROUP_STATUSES = ["OPEN", "SETTLED", "ARCHIVED"];
export const PIX_KEY_TYPES = ["CPF", "CNPJ", "EMAIL", "PHONE", "RANDOM"];
export const PIX_KEY_TYPE_LABELS = {
    CPF: "CPF",
    CNPJ: "CNPJ",
    EMAIL: "E-mail",
    PHONE: "Telefone",
    RANDOM: "Chave aleatória",
};
export const SPLIT_MODE_LABELS = {
    EQUAL: "Igualmente",
    WEIGHT: "Por peso",
    EXACT: "Valor exato",
    ITEMS: "Por item",
};
export const SETTLEMENT_METHOD_LABELS = {
    PIX: "Pix",
    CASH: "Dinheiro",
    OTHER: "Outro",
};
//# sourceMappingURL=types.js.map